import React from "react";
import Card from "components/card";

const SummaryHeader = (props) => {
  const {title, icon: Icon , description, children, rightNav, color } = props;
  
  return (
    <Card className={`rounded-2xl overflow-hidden p-8 relative gradient ${color} text-white`}>
      <div className="flex items-center gap-3 w-full">
        <div className="p-3 rounded-xl sm:rounded-2xl bg-white/20 backdrop-blur-xl border border-white/30 shadow-2xl flex-shrink-0">
          <div className="text-white flex items-center justify-center">
            <Icon className="w-8 h-8" />
          </div>
        </div>
        <div className="min-w-0">
          <h1 className="text-[28px] font-semibold text-white">
            {title}
          </h1>
          <p className="description text-[14px]">
            {description}
          </p>
        </div>
        <div className="absolute top-8 right-5 mr-3">
					{rightNav}
				</div>
      </div>
      {children && 
        <div className="flex items-center gap-6 mt-6">
          {children}
        </div>
      }
    </Card>
    
  );
};

export default SummaryHeader;
